import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { TransformHero, TrustBar } from "../components/transform/TransformTop";
import { TransformPillars } from "../components/transform/TransformPillars";
import { JourneySection } from "../components/transform/TransformMid";
import { EnterpriseOpportunities } from "../components/transform/EnterpriseOpportunities";
import { HumanAiAmplification } from "../components/transform/HumanAiAmplification";
import { CaseStudies, TransformCta } from "../components/transform/TransformBottom";

const HowWeTransform = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="min-h-screen w-full bg-white">
      <Navbar />
      <main>
        <TransformHero />
        <TrustBar />
        <TransformPillars />
        <JourneySection />
        <EnterpriseOpportunities />
        <HumanAiAmplification />
        <CaseStudies />
        <TransformCta />
      </main>
      <Footer />
    </div>
  );
};

export default HowWeTransform;
